// extracted by mini-css-extract-plugin
export default {"PACreateFormContainer":"qQP0SBds","PACreateHeaderPanel":"QBkLRnMG"};